import { ValueGetterParams } from "ag-grid-community";
import { ReportsTableData } from "@/store/reports/utils/types/types";
import { getScheduleTitleAndTooltip } from "@/components/pages/reports/components/table/utils/helpers/getScheduleTitleAndTooltip";

export const reportsFrequencyValueGetter = ({
  data,
}: ValueGetterParams<ReportsTableData>) =>
  data?.schedule ? getScheduleTitleAndTooltip(data.schedule).title : undefined;
